import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {Formats} from "../../../../../constants/Formats";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import dayjs from "dayjs";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";
import {Link, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {DictItemDto} from "../../../../../modules/dict/dto/DictItemDto";
import {DictClassCode} from "../../../../../modules/vms/constants/DictClassCode";
import {DictClassApi} from "../../../../../modules/dict/api/DictClassApi";
import {useConfirm} from "material-ui-confirm";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {SiteApi} from "../../../../../modules/vms/api/SiteApi";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import RequestVisitorDetailDialog from "../../../components/RequestVisitorDetailDialog";
import StringUtils from "../../../../../utils/StringUtils";
import {VisitRequestClassify} from "../../../../../modules/vms/enums/VisitRequestClassify";
import {VisitorStatus} from "../../../../../modules/vms/enums/VisitorStatus";
import {VisitorAccessLogDto} from "../../../../../modules/vms/dto/VisitorAccessLogDto";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";

export type SearchResultProps = {
    searchResult: Array<RequestVisitorDto>;
    onSearch: () => void;
    onOpenDetailRegisterDialog: (record: RequestVisitorDto) => void;

    onOpenDetailDialog: (record: RequestVisitorDto) => void;

};

const SearchResult: React.FC<SearchResultProps> = (props) => {
    const intl = useIntl();
    const confirm = useConfirm();
    const [visitorTypes, setVisitorTypes] = useState(new Array<DictItemDto>());

    useEffect(() => {
        // 查询访问目的字典项
        fetchDictClassList();

    }, []);
    const fetchDictClassList = async () => {
        const codes = new Array<string>(DictClassCode.VMS_VISITOR_TYPE);
        const responseResult = await DictClassApi.getDictClassList(codes);
        if (responseResult.status === HttpStatus.SUCCESS) {
            for (let dictClass of responseResult.data) {
                switch (dictClass.code) {


                    case DictClassCode.VMS_VISITOR_TYPE:
                        setVisitorTypes(dictClass.dictItems);
                        break;


                }
            }
        }
    };


    const handleVisitorDetail = async (record: RequestVisitorDto) => {
        if (record.checkOutLog != null) {
            props.onOpenDetailDialog(record);

        } else {
            props.onOpenDetailRegisterDialog(record);

        }

    };

    const handleDelete = async (record: RequestVisitorDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(async () => {
                const responseResult = await RequestVisitorApi.deleteVisitor(record.id);
                if (responseResult.status === HttpStatus.SUCCESS) {
                    MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
                    props.onSearch()
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    // @ts-ignore
    return (
        <div>

            <TableContainer>
                <Table size="small"
                       sx={{minWidth: 2000, overflow: 'auto'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{intl.formatMessage({id: 'VMS_VISIT_REQUEST_NUMBER'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ARRIVE_DATE'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'VMS_VISIT_REQUEST_CLASSIFY'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_NAME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_VISIT_CODE"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_STATUS"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_CHECKIN_TIME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_CHECKOUT_TIME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.searchResult.map((row, index) => {
                            const checkOutLog = row.checkOutLog && Object.assign(new VisitorAccessLogDto(), row.checkOutLog);
                            const checkInLog = row.checkInLog && Object.assign(new VisitorAccessLogDto(), row.checkInLog);
                            const visitRequest = row.visitRequest ? row.visitRequest : new VisitRequestDto();
                            return (<TableRow key={row.id}>
                                <TableCell>{row.visitRequest?.number}</TableCell>
                                <TableCell>{StringUtils.formatDate(visitRequest.arriveStartDate) + " " + StringUtils.formatTime(visitRequest.arriveStartTime)}&nbsp;-&nbsp;
                                    {StringUtils.formatDate(visitRequest.arriveEndDate)+ " " + StringUtils.formatTime(visitRequest.arriveEndTime)}</TableCell>
                                <TableCell><FormattedMessage
                                    id={VisitRequestClassify.Map.get(visitRequest.classify)}/></TableCell>
                                <TableCell>{row.fullName}</TableCell>
                                <TableCell>{row.company}</TableCell>
                                <TableCell>{visitRequest.hostFullName}</TableCell>
                                <TableCell>{row.visitCode}</TableCell>
                                <TableCell>{row.plateNumber}</TableCell>
                                <TableCell><FormattedMessage id={VisitorStatus.Map.get(row.status)}/></TableCell>
                                <TableCell>{checkInLog?.fetchAccessDateTime()}</TableCell>
                                <TableCell>{checkOutLog?.fetchAccessDateTime()}</TableCell>
                                <TableCell>
                                    <Stack direction={'row'} spacing={2}>
                                        <Link href={'javascript:void(0)'} onClick={() => handleVisitorDetail(row)}>
                                            <FormattedMessage id={'COMMON_DETAIL'}/>
                                        </Link>
                                        <Link href={'javascript:void(0)'} onClick={() => handleDelete(row)}>
                                            <FormattedMessage id={'COMMON_DELETE'}/>
                                        </Link>
                                    </Stack>
                                </TableCell>
                            </TableRow>)
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default SearchResult;